import eventStates from 'helpers/eventStates';

const ACTIVE_STATES = [eventStates.ACTIVE, eventStates.ACCEPTED, eventStates.CONFIRMED];

export default ACTIVE_STATES;
